/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Language_Update_FailedInputs */

const en_common_language_update_failed = /** @type {(inputs: Common_Language_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update language. Please try again.`)
};

const es_common_language_update_failed = /** @type {(inputs: Common_Language_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar el idioma. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Failed to update language. Please try again." |
*
* @param {Common_Language_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_language_update_failed = /** @type {((inputs?: Common_Language_Update_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Language_Update_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_language_update_failed(inputs)
	return en_common_language_update_failed(inputs)
});